import React from 'react'

export default function Row({
  children,
  bottomGutter = false,
  style,
  justify = 'space-between',
  className,
}: any) {
  return (
    <div
      className={className}
      style={{
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        justifyContent: justify,
        marginBottom: bottomGutter ? 12 : 0,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
